// Functionality revolving around concordium domain types, which require the WASM at entrypoint `@concordium/rust-bindings/wallet`.
export * from '../wasm/index.js';
